import { useMutation, useQueryClient } from '@tanstack/react-query';
import { patchCropFavorite } from '../../../../api/crop-trends/mutations/patchCropFavorite';

export const usePatchCropFavorite = () => {
  const queryClient = useQueryClient();

  return useMutation(patchCropFavorite, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['crop-favorite'] });
      queryClient.invalidateQueries({ queryKey: ['favorite-crop-prices'] });
    },
  });
};
